const version3 = [
    //借款申请第二版

    {
      path: '/version3/base-info',
      component: () => import('@/pages/version3/credit/base-info.vue'),
      meta: {
        title: '个人信息',
        keepAlive: false
      }
    },
    {
      path: '/version3/person-contact',
      component: () => import('@/pages/version3/credit/person-contact.vue'),
      meta: {
        title: '联系人信息',
        keepAlive: false
      }
    },
    //撞库申请免费用户
    {
      path: '/version3/match-loading-f',
      component: () => import('@/pages/version3/credit/match-loading-f.vue'),
      meta: {
        title: '审核中',
        keepAlive: false
      }
    },
    //撞库申请付费用户
    {
      path: '/version3/match-loading-v',
      component: () => import('@/pages/version3/credit/match-loading-v.vue'),
      meta: {
        title: '审核中',
        keepAlive: false
      }
    },



    //申请成功结果
    {
      path: '/version3/result-page-success',
      component: () => import('@/pages/version3/credit/result-page-success.vue'),
      meta: {
        title: '审核结果',
        keepAlive: false
      }
    },
    //申请失败结果
    {
      path: '/version3/result-page-fail',
      component: () => import('@/pages/version3/credit/result-page-fail.vue'),
      meta: {
        title: '审核结果',
        keepAlive: false
      }
    },
    //审核中
    {
      path: '/version3/result-page-review',
      component: () => import('@/pages/version3/credit/result-page-review.vue'),
      meta: {
        title: '审核结果',
        keepAlive: false
      }
    },
    //p0协议页面
    {
      path: '/version3/agreement',
      component: () => import('@/pages/version3/credit/agreement.vue'),
      meta: {
        title: '协议',
        keepAlive: false
      }
    },


    //智能借款方案
    {
      path: '/version3/right-introduce',
      component: () => import('@/pages/version3/vip/right-introduce.vue'),
      meta: {
        title: '智能借款方案',
        keepAlive: false
      }
    },
    //智能借款方案
    {
      path: '/version3/vipright',
      component: () => import('@/pages/version3/vip/vipright.vue'),
      meta: {
        title: '智能借款方案',
        keepAlive: false
      }
    },

    //品牌故事
    {
      path: '/version3/other/aboutme',
      component: () => import('@/pages/version3/other/aboutme.vue'),
      meta: {
        title: '品牌故事',
        keepAlive: false
      }
    },

  ]
export default version3



// WEBPACK FOOTER //
// ./src/router/modules/version3.js